import type { ComponentType } from "react"
import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import userService from "services/authService"

interface IProps {
  // biome-ignore lint/suspicious/noExplicitAny: ProtectedRoute is a HOC that wraps any component type
  component: ComponentType<any>
  userRoles: Array<string>
}

export function ProtectedRoute(props: IProps) {
  const { component: Component } = props
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userHasRequiredRole, setUserHasRequiredRole] = useState(false)

  useEffect(() => {
    userService
      .getUser()
      .then((user) => {
        if (user === undefined) {
          setIsAuthenticated(false)
          setIsLoading(false)
        } else {
          userService.getRolesAssignedToUser().then((roles) => {
            setIsAuthenticated(true)
            setIsLoading(false)
            const hasRole = props.userRoles.some((x) => roles?.includes(x))
            setUserHasRequiredRole(hasRole)
          })
        }
      })
      .catch(() => {
        setIsAuthenticated(false)
        setIsLoading(false)
      })
  })

  return isLoading ? null : isAuthenticated ? (
    userHasRequiredRole ? (
      <Component {...props} />
    ) : (
      <Navigate to={{ pathname: "/" }} state="/" />
    )
  ) : (
    <Navigate to={{ pathname: "/login" }} state="/" />
  )
}
